import { api } from '@/api'

export function deleteServiceProviderAction(id: string) {
  return api.v2.delete(`/service-providers/${id}`)
}
